
import { defineComponent } from 'vue'
import UIButton from '~/components/Common/UI2/Buttons/UIButton.vue'

export default defineComponent({
  name: 'OnboardStepsHeader',
  components: {
    UIButton
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    },
    showDashboardButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['sign-out']
})
